import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson2DefaultStartCode = `// Cairo is a typed language. A popular type is \`felt252\`, which is like a number.
// The function below is missing some types and there are a couple errors. Can you fix this?
${doNotModifyCodeAbove}`;

export const lesson2DefaultMiddleCode = `// TODO: Edit this function
fn add(a: felt252, b) {
    let c = a + b;
    return c;
}
`;

export const lesson2DefaultEndCode = `${doNotModifyCodeBelow}
fn main() -> felt252 {
    add(3, 5) 
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
}`;
